export default {
  CreateTitle1: '您需要将访问规则关联到目标网关实例上。关联后，网关实例通过匹配规则过滤流量。未关联网关则规则不会生效。若您的网关关联多条规则，您可在',
  CreateTitle2: '下，进行优先级设置。', // title1,2本为一句话，因为有可点击链接，所以拆分成三句话,原句为您需要将访问规则关联到目标网关实例上。关联后，网关实例通过匹配规则过滤流量。未关联网关则规则不会生效。若您的网关关联多条规则，您可在访问控制-已关联网关下，进行优先级设置。
  CreateTitle3: '流量默认按照访问控制规则优先级，从高到低进行匹配流量。若您未设置优先级或优先级相同，将默认按照创建时间早的规则优先生效。没有匹配上的流量，系统默认放行。',
  OutDirectionToolTip: '出方向：指从网关设备所在的本地分支访问外部的流量。',
  InDirectionToolTip: '入方向：指从外部访问网关设备所在的本地分支的流量。',
  InputRuleName: '请填写规则名称',
  RuleNameMsg: '请填写名称，支持长度2-20字符的中英文、数字、下划线、减号',
  SelectDirection: '请选择控制方向',
  SelectControlType: '请选择控制类型',
  ControlDomain: '控制域名',
  ControlDomainMsg: '请填写控制域名',
  ControlDomainPH: '请填写域名，支持多个，一个一行。支持泛域名，以*开头，如：*.domain.com',
  BaseOnDomain: '基于域名',
  PleaseInputMsg: '请填写1-50范围内的正整数，不设置则默认为50',
  AclCreatePriority: '默认优先级为初始配置，修改只针对新关联网关生效。若您需要针对不同网关设置不同优先级，请前往', // 默认优先级为初始配置，修改只针对新关联网关生效。若您需要针对不同网关设置不同优先级，请前往已关联网关单独设置
  RuleNameRepeat: '规则名称重复',
  DomainFormatError: (val: string) => `域名${val}格式有误`,
  DomainRepeat: (val: string) => `域名 ${val} 重复`,
  DomainBased: '特别提醒：为了使基于域名ACL生效， 您还需要在您的pc上配置DNS为CPE的IP',
  IpPlaceholder: '请填写IP地址或者CIDR网段格式，放空视为不限，多个换行隔开',
  Ipv6Placeholder: '请填写IPv6网段地址，放空视为不限，多个换行隔开',
  IPv6Examp: '例：2000:a001::/64 或 2000:b001::1/128',
}